import React from "react";
import {Box, Columns, Form, Heading, Table} from "react-bulma-components";
import CashSaleRow from "./CashSaleRow";
import Collapsible from "react-collapsible";


export default function CashSales({data}){



    return (
        <Box>
            <Collapsible
                trigger={"Cash Sales"}
                triggerOpenedClassName={"title"}
                className={"title"}
            >
                <Columns>
                    <Table size={"fullwidth"}>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Address</th>
                                <th>Amount</th>
                                <th>Source</th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.map(cashSale => (
                            <CashSaleRow
                                data={cashSale}
                            />
                        ))}
                        </tbody>
                    </Table>
                </Columns>
            </Collapsible>
        </Box>
    )

}